<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col md="3" cols="12">
                      <v-autocomplete
                        label="Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="asset_category_id.value.value"
                        :items="getAssetCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="asset_category_id.errorMessage.value"
                        autocomplete="off"
                        :loading="statusTypeLoading"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col md="3" cols="12">
                        <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                        >
                    </v-col>
                    
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Asset Summary Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2 justify-items-between">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

  <input
    ref="csvInput"
    type="file"
    style="display: none"
    @change="handleCSVFile"
  />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {},
  data: () => ({
    itemsPerPage: "-1",
    panel: [0],
    search: "",
    dialog: false,
    data: {},

    categoryLoading: false,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "100px", sortable: false },
      { title: "Asset Category", key: "asset_category", align: "left", sortable: false, width: "100px" },
      { title: "Name of Assets", key: "name", align: "left", sortable: false },
      { title: "Qty", key: "qty", align: "left", sortable: false },
      { title: "Acquistion on cost", key: "acquisition_cost", align: "left", sortable: false },
      { title: "Dep Rate", key: "dep_rate", align: "left", sortable: false },
      { title: "Present Value", key: "present_value", align: "left", sortable: false },
      { title: "Acc Dep opening", key: "acc_dep_opening", align: "left", sortable: false },
      { title: "Dep. this Period", align: "center", key: "dep_this_period", sortable: true },
      { title: "Acc. Depreciation", key: "acc_depreciation", align: "left", sortable: false },
      { title: "Carrying Value", align: "center", key: "carrying_value", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if(this.$store.getters.getAssetCategoryList.length == 0){
      this.categoryLoading = true;
      this.$store.dispatch('getAssetCategoryList').then((response) => {
          this.categoryLoading = false;
      })
    };

  },
  computed: {
    getSchema() {
      console.log(this.$store.getters.getAssetSummaryReport)
      return this.$store.getters.getAssetSummaryReport;
    },
    getAssetCategoryList(){
      let data = this.$store.getters.getAssetCategoryList;
      if(data.length > 0){
          return data.filter((item) => item.status == 1);
      }
      return [];
    },

  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        //
      }),
    });

    const asset_category_id = useField("asset_category_id");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      loading.value = true;
      store
        .dispatch("getAssetSummaryReport", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      asset_category_id,
      submit,
      errorMessages,
      loading,
    };
  },
  methods: {
    editItem(item) {
      this.$store.commit("SET_EDITING_ASSET_REGISTRATION", item);
      this.$router.push({ name: "asset-registration" });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Asset Registration List", "asset_registration_list_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [[ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "asset_registration_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "asset_registration_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.$refs.searchButton.$el.click();
  },  
};
</script>
